function createElement(tag, attrs, children) {
  var el = document.createElement(tag)
  attrs = attrs || {}
  Object.keys(attrs).forEach(function (k) { if (k === 'class') el.className = attrs[k]; else el.setAttribute(k, attrs[k]) })
  ;(children || []).forEach(function (c) {
    if (c === null || c === undefined) return
    el.appendChild(typeof c === 'string' ? document.createTextNode(c) : c)
  })
  return el
}

function createTypingIndicator() {
  return createElement('div', { class: 'wc-message wc-bot wc-typing', 'aria-live': 'polite', 'aria-label': 'Chargement en cours' }, [
    createElement('span', { class: 'wc-typing-dot' }),
    createElement('span', { class: 'wc-typing-dot' }),
    createElement('span', { class: 'wc-typing-dot' })
  ])
}

export { createTypingIndicator }
